import Head from 'next/head';

import { getArticlesByPage } from '@/helpers/helpers_data';

import ArticleCards from '@/components/ArticleCards';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Pagination from '@/components/Pagination';

const ARTICLES_PER_PAGE = 10;

export async function getStaticPaths() {
  const paths = [];

  // Use the getArticles function to get the total number of articles.
  const data = await getArticlesByPage({ limit: 1 });
  const count = data.total;
  const pages = [...Array(Math.ceil(count / ARTICLES_PER_PAGE)).keys()];

  pages.map((page_number) => {
    paths.push({
      params: {
        page_number: (page_number + 1).toString()
      }
    });
  });

  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  // Get articles.
  const data = await getArticlesByPage({
    limit: ARTICLES_PER_PAGE,
    offset: ARTICLES_PER_PAGE + (params.page_number - 2) * ARTICLES_PER_PAGE
  });

  return {
    props: {
      articles: data.articles,
      page: params.page_number,
      totalArticles: data.total
    }
  };
}

const Page = ({ articles = [], page = 1, totalArticles = 0 }) => {
  return (
    <div className="page-wrapper">
      <Head>
        <title>Find Home Service Pros Near You</title>
        <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />

        <link rel="canonical" href="https://callapro.com/news/" />
      </Head>
      <Header />
      <ArticleCards articles={articles} headline={`More Articles`} />
      <Pagination totalPages={totalArticles <= ARTICLES_PER_PAGE ? 1 : Math.ceil((totalArticles - ARTICLES_PER_PAGE) / ARTICLES_PER_PAGE + 1)} page={page} perPage={ARTICLES_PER_PAGE} path={`/news`} />
      <Footer />
    </div>
  );
};

export default Page;
